import { useGetFundCodeFromQuery } from '@/modules/invest/hooks/useGetFundCodeFromQuery';
import { useGetFunds } from './useGetFunds';

export const useFindFundByFundCode = (fundCode: string) => {
  const { fundsList, isLoading } = useGetFunds();

  const fund = fundsList.find((fund) => fund.fundCode === fundCode);

  return { fund, isLoading };
};

export const useFindFundByQuery = () => {
  const fundCode = useGetFundCodeFromQuery();

  return useFindFundByFundCode(fundCode);
};
